import React from "react";

import { EventKeyBettingOffer } from "@gp/models";
import { EventKeyOffer, MainOfferStore } from "@gp/offer";
import { observer } from "mobx-react";

import { OutrightOfferRow } from "./components/OutrightOfferRow";

export default observer(function EventOutrightOffer(props: {
	isExpanded: boolean;
	eventOffer: Map<string, EventKeyOffer> | null;
	offerStore: MainOfferStore;
	ignoreIsExpanded?: boolean;
}) {
	if (props.eventOffer == null || props.eventOffer.size === 0) {
		return null;
	}

	const eventKeys = Array.from(props.eventOffer.values());

	if (eventKeys.length === 0) {
		return null;
	}

	return (
		<>
			{(props.ignoreIsExpanded || props.isExpanded) &&
				eventKeys.map((k) => {
					const offers = Array.from(
						props.offerStore.keyOffersMap.get(k.id)?.values() || []
					).sort(function (
						a: EventKeyBettingOffer,
						b: EventKeyBettingOffer
					) {
						return a.value - b.value;
					});

					return (
						<div
							key={k.id}
							className="match--outright__bets match__bets"
						>
							<div className="match--outright__block match__block u-mar--top--reset">
								<div className="match__grid u-padd--reset">
									<OutrightOfferRow
										eventKey={k}
										offers={offers}
									/>
								</div>
							</div>
						</div>
					);
				})}
		</>
	);
});
